export const changeproductionDateReducer = (state = '', action) => {
  switch (action.type) {
    case "CHANGE_PRODUCTION_DATE":
      return action.payload.productionDateSelected;
    default:
      return state;
  }
};
